import React, { useEffect, useState } from 'react';
import { Formik, Form, Field } from 'formik';
import styles from './Filter.module.css';
import TitleSecondary from "../Title/TitleSecondary";

function Filter({ data, onFilterSubmit, title, filterOptionFromUrl = '' }) {
    const filterString = typeof filterOptionFromUrl === 'string' ? filterOptionFromUrl : '';

    const selectedFilters = filterString.split(',').filter(Boolean);

    const initialValues = data.reduce((values, datum) => {
        values[datum.value] = selectedFilters.includes(String(datum.value));
        return values;
    }, {});

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={(values, { setSubmitting }) => {
                onFilterSubmit(values);
                setSubmitting(false);
            }}
        >
            {formik => (
            <Form className={styles.container}>
                <h3 className={styles.title}>{title}</h3>
                <ul className={styles.filterList}>
                    {data.map((datum) => (
                        <li key={datum.value}>
                            <Field
                                type="checkbox"
                                name={datum.value}
                                id={datum.value}
                                className={styles.inputFiltre}
                                onChange={e => {
                                    formik.handleChange(e);
                                    formik.submitForm();
                                }}                            />
                            <label htmlFor={datum.value} className={styles.cochage}>{datum.label}</label>

                        </li>
                    ))}
                </ul>
            </Form>
            )}
        </Formik>
    )
}

export default Filter;
